import { defaultPaddingLeft, mobileDefaultPaddingLeft } from '../../../../../constants/sizes';
import Device from '../../../../../constants/deviceSizes';

export default {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: `25px ${defaultPaddingLeft}px`,
    boxSizing: 'border-box',
    alignItems: 'flex-start',
    [Device.mobile]: {
      padding: `25px ${mobileDefaultPaddingLeft}px`
    }
  },
  password: {
    width: '50%',
    marginTop: 20,
    [Device.mobile]: {
      width: '100%'
    }
  },
  loading: {
    height: '80vh',
    width: '100%'
  },
  actionButtonsContainer: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'flex-start'
  }
};
